import * as React from 'react'

import { Box, Chip, Link, Typography } from '@design/pt-ui'
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material'

import SimpleModal from './SimpleModal'
import { translateWithUserLocale } from '../utils/i18n'

const AiInfoModal = () => {
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <Chip
        className="cp-ai-info-chip"
        variant="outlined"
        size="small"
        clickable={true}
        onClick={() => setOpen(true)}
        icon={<InfoOutlinedIcon fontSize="small" />}
        label={translateWithUserLocale('ai_info.label')}
      />
      <SimpleModal
        width={'auto'}
        title={translateWithUserLocale('ai_info.label')}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        scroll="paper">
        <Box sx={{ px: 3, py: 2, maxWidth: '640px' }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {translateWithUserLocale('ai_info.description')}
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {translateWithUserLocale('ai_info.further_information')}:{' '}
            <Link
              href={translateWithUserLocale('ai_info.link_url')}
              target="_blank"
              rel="noopener noreferrer">
              {translateWithUserLocale('ai_info.link_label')}
            </Link>
          </Typography>
        </Box>
      </SimpleModal>
    </>
  )
}

export default AiInfoModal
